import SDK from "SDK"
import cloneDeep from "lodash.clonedeep"
import { apiGetImInfo } from "@/api/user"

let isFirstTime = true
let startTime

export default {
  data() {
    return { closeMassage: false }
  },
  methods: {
    onMsg(msg) {
      // const { from, to, time, idServer } = msg
      const res = cloneDeep(JSON.parse(msg.content))
      // const resultType = res.type // 结果类型 notify(通知类型),chat(聊天类型)
      // const body = res.body

      // 自定义消息, 消息来源为智能客服
      console.log("BaseApp-------消息回调", res)
      if (res.module === "notify-center") {
        this.$footerNotify({
          title: "业务消息",
          message: res.body.title,
          type: "info",
          duration: 5000
        })
        this.$store.commit("user/SET_UNREADNOTIFYCOUNT", this.$store.state.user.unreadNotifyCount + 1)
      }

      if (res.module === "importExport_notify") {
        const { fileName, operationType, taskStatusName } = JSON.parse(res.body.title)
        this.$ImportExportNotify({
          title: operationType == 0 ? `导入任务` + taskStatusName : "导出任务" + taskStatusName,
          message: fileName,
          type: "info",
          duration: 5000,
          value: JSON.parse(res.body.title)
        })
        this.$store.dispatch("user/getCurrentTask")
      }
    },
    async onConnect() {
      console.log("连接成功")
      console.log("init----------------------wechat")
    },
    onWillReconnect() {
      // 此时说明 SDK 已经断开连接, 请开发者在界面上提示用户连接已断开, 而且正在重新建立连接
      console.log("即将重连-------------------")
      this.$nim.connect()
      // 重连上报
      // apiRecordReport({
      //   message: JSON.stringify({
      //     error: "即将重连回调",
      //     describe: "即将重连"
      //   })
      // })
    },
    onDisconnect(error) {
      // 此时说明 SDK 处于断开状态, 开发者此时应该根据错误码提示相应的错误信息, 并且跳转到登录页面
      if (error) {
        switch (error.code) {
          case 417: // 重复登录, 已经在其它端登录了, 请跳转到登录页面并提示错误
          case "kicked":
            this.$message({
              message: "检测到账号在其他设备登录,3秒后自动退出系统。",
              type: "info",
              duration: 3000
            })

            setTimeout(() => {
              // 被踢, 请提示错误后跳转到登录页面
              if (this.userInfo.userName !== "钴蓝") {
                this.$store.dispatch("user/clearGlobal")
                location.reload()
              }
            }, 3000)

            break
          default:
            break
        }
      }
    },
    // 错误上报弹窗提示
    errorTipsUploader(error) {
      if (error?.message == "超时" || error?.code == "LINK_ERROR") {
        this.closeMassage = this.$message({
          type: "error",
          dangerouslyUseHTMLString: true,
          duration: 0,
          showClose: true,
          customClass: "custom-error",
          message:
            "<strong>系统检测到网络有波动，导致消息无法接收，请重新连接</strong> <div style='margin: 12px;margin-left: 0;margin-bottom: 0;display: flex;justify-content: flex-end;margin-right: 0;'><button class='el-button el-button--danger el-button--mini' onclick='directExec()' class='reload-page'>连接</button></div>"
        })
      }
    },
    onError(error) {
      // 错误上报
      if (isFirstTime) {
        // 记录进入方法的时间戳
        startTime = new Date().getTime()
        isFirstTime = false
        // 首次会弹出 后续5分钟内不弹提示 im在这持续过程重连
        // this.errorTipsUploader(error)
      }
      // 两种情况 1.网络因素 一直无法连接成功 2.系统c盘满了 im自己断开
      const currentTime = new Date().getTime()
      // 判断是否已经过了5分钟
      if (currentTime - startTime >= 5 * 60 * 1000) {
        // 5分钟还没有连接成功，弹出提示
        // this.errorTipsUploader(error)
        isFirstTime = true
      }
    },
    // 接收离线消息
    onoFfLinemsgs(res) {
      console.log("离线消息", res)
      const msgs = res.msgs
      // 如果同步数据则不处理离线消息, 一般是在重新登录时会同步数据, 此时以同步数据为准即可
      if (this.isSyncDatabase) return
      msgs.forEach(resu => this.onMsg(resu))
    }
  },
  async created() {
    const imData = await apiGetImInfo()
    // 初始化 im
    this.$nim = SDK.NIM.getInstance({
      debug: true, // 是否开启日志，将其打印到console。集成开发阶段建议打开。
      appKey: process.env.VUE_APP_IMAPPKEY,
      account: imData.data.id,
      token: imData.data.token,
      onconnect: this.onConnect,
      onwillreconnect: this.onWillReconnect,
      ondisconnect: this.onDisconnect,
      onerror: this.onError,
      onmsg: this.onMsg,
      onofflinemsgs: this.onoFfLinemsgs
    })
  }
}
